import React, { useEffect, useState } from 'react';
import {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonCard,
    IonCardHeader,
    IonCardTitle,
    IonCardContent,
    IonButton,
    IonItem,
    IonLabel,
    IonRadioGroup,
    IonRadio,
    IonList,
    IonText,
} from '@ionic/react';

interface RankingTestQuestion {
    question: string;
    pattern: (string | null)[];
    options: string[];
    correctAnswer: string;
    //missingIndex: number;
    type: "image" | "position" | "nearfar" | "sameelement";
}

const getRandomInt = (min: number, max: number): number =>
    Math.floor(Math.random() * (max - min + 1)) + min;

function getRandomItems<T>(arr: T[], count: number): T[] {
    const shuffled = [...arr].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, count);
}

const getAlphabet = (index: number): string => {
    const charCode = "A".charCodeAt(0) + index;
    return String.fromCharCode(charCode);
};

const patternBackground = {
    "animals": ["elephant.png", "zebra.png", "monkey.png", "horse.png", "wolf.png", "yak.png", "tiger.png", "lion.png", "snake.png", "sheep.png", "rhino.png", "kangaroo.png", "rat.png", "rabbit.png", "dog.png", "cat.png", "cow.png", "pig.png", "fox.png", "lemur.png", "leopard.png", "joey.png", "gorilla.png", "goat.png", "giraffe.png", "donkey.png", "cheetah.png", "camel.png", "buffalo.png", "bison.png", "bear.png"],
    "insects": ["butterfly.png", "bee.png", "spider.png", "ant.png", "ladybug.png", "mosquito.png", "grasshoper.png", "dragonfly.png", "beetle.png", "caterpillar.png", "wasp.png", "moth.png", "cricket.png", "firefly.png", "termite.png", "leafhopper.png"],
    "flowers": ["sunflower.png", "lotus.png", "rose.png", "lily.png", "daisy.png", "tulip.png", "marigold.png", "jasmine.png", "hibiscus.png", "daffodil.png", "poppy.png", "lavender.png", "orchid.png", "dahlia.png", "aster.png", "magnolia.png"],
    "vehicles": ["car.png", "bicycle.png", "airplane.png", "ambulance.png", "bike.png", "bus.png", "truck.png", "motorcycle.png", "scooter.png", "firetruck.png", "train.png", "policecar.png", "jeep.png", "rickshaw.png", "ship.png", "boat.png", "yacht.png"],
    "things": ["binoculars.png", "book.png", "candles.png", "ball.png", "dolls.png", "pencil.png", "eraser.png", "crayon.png", "schoolbag.png", "chair.png", "table.png", "cup_image.png", "clock.png", "mug.png", "scissors.png", "sharpener.png"]
};

const positionBackground = {
    "Book Shop": "bookshop.png", "Ice Cream Truck": "icecreamtruck.png", "School Bus": "schoolbus.png", "Zoo Gate": "zoogate.png"
};

const boysCharacters = {
    "Rahul": "boy1.png", "Abhay": "boy2.png", "Sahil": "boy3.png", "Sidharth": "boy4.png", "Rohit": "boy5.png", "Kartik": "boy6.png", "Nakul": "boy7.png", "Vinay": "boy8.png", "Sumit": "boy9.png", "Manish": "boy10.png"
}

const girlsCharacters = {
    "Ananya": "girl1.png", "Kirti": "girl2.png", "Kavya": "girl3.png", "Sneha": "girl4.png", "Priya": "girl5.png", "Anjali": "girl6.png", "Nidhi": "girl7.png", "Tina": "girl8.png", "Rashi": "girl9.png", "Sakshi": "girl10.png",
}

const positionArray = ["first", "second", "third", "fourth", "fifth", "sixth", "seventh", "eighth", "nineth", "tenth"];
const positionNoArray = ["1st", "2nd", "3rd", "4th", "5th", "6th", "7th", "8th"];



const RankingTest: React.FC = () => {
    const [showImage, setShowImage] = useState(false);
    const [question, setQuestion] = useState<RankingTestQuestion | null>(null);
    const [selected, setSelected] = useState<string | null>(null);
    const [selectedNearFarBackground, setSelectedNearFarBackground] = useState<string | null>(null);
    const [selectedElement, setSelectedElement] = useState<string | null>(null);

    const createNewQuestion = () => {
        const patternType = getRandomInt(0, 3);
        const q = 
        patternType === 0
        ? generateImageRanking()
        : patternType === 1
        ? generatePositionRanking()
        : patternType === 2
        ? generateNearFarRanking()
        : generateSameElementRanking()
        setQuestion(q);
        setSelected(null);
    }

    const generateSameElementRanking = (): RankingTestQuestion => {
        const unitLength = 10;
        const categories = Object.keys(patternBackground) as (keyof typeof patternBackground)[]; console.log(categories)
        const randomCategory = categories[Math.floor(Math.random() * categories.length)];

        const startIndex = getRandomInt(0, 10);


        const leftOrRight = Math.random() < 0.5 ? 'left' : 'right';

        const selectedTopic = patternBackground[randomCategory];
        const selectedPosition = getRandomInt(0, 7);

        const pattern: string[] = [];
        const totalLength = 1;

        const patternUnit = getRandomItems(selectedTopic, totalLength);
        setSelectedElement(patternUnit[0]);
        const selectedAlphabets: string[] = [];

        for (let i = 0; i < unitLength; i++) {
            selectedAlphabets.push(getAlphabet(startIndex + i * 1));
            pattern.push(patternUnit[0] + '-' + getAlphabet(startIndex + i * 1));
        }
        //console.log(pattern[selectedPosition])
        const correctAnswer = leftOrRight === 'left' ? pattern[selectedPosition].split('-')[1] : pattern[unitLength - (selectedPosition + 1)].split('-')[1];

        const options = new Set<string>();
        options.add(correctAnswer);
        while (options.size < 4) {
            const distractor = selectedAlphabets[getRandomInt(0, selectedAlphabets.length - 1)];
            if (!options.has(distractor)) {
                options.add(distractor);
            }
        }

        return {
            question: "___________ is the " + positionNoArray[selectedPosition] + " from the " + leftOrRight + " end in the given arrangement.",
            pattern: pattern,
            options: Array.from(options).sort(() => Math.random() - 0.5),
            correctAnswer,
            //selectedPosition,
            type: "sameelement",
        };
    }


    const generateNearFarRanking = (): RankingTestQuestion => {
        const allCharacters = [...Object.entries(boysCharacters), ...Object.entries(girlsCharacters)];
        const shuffledCharacters = [...allCharacters].sort(() => 0.5 - Math.random()).slice(0, 5);
        const pattern = shuffledCharacters.map(([name, img]) => `${name}-${img}`);
        const namesOnly = shuffledCharacters.map(([name]) => name);

        const categories = Object.keys(positionBackground) as (keyof typeof positionBackground)[];
        const randomCategory = categories[Math.floor(Math.random() * categories.length)];
        setSelectedNearFarBackground(positionBackground[randomCategory])

        console.log(randomCategory)

        const questionType = getRandomInt(1, 3);
        let question = "";
        let correctAnswer = "";
        let options: string[] = [];

        if (questionType === 1) {
            question = `__________ is standing near the ${randomCategory}?`;
            correctAnswer = namesOnly[namesOnly.length - 1];
            options = Array.from(new Set([correctAnswer, ...getRandomItems(namesOnly.filter(n => n !== correctAnswer), 3)]));
        } else if (questionType === 2) {
            const idx1 = getRandomInt(0, namesOnly.length - 3);
            const idx2 = idx1 + 2;
            question = `____________ is between ${namesOnly[idx1]} and ${namesOnly[idx2]}?`;
            correctAnswer = namesOnly[idx1 + 1];
            options = Array.from(new Set([correctAnswer, ...getRandomItems(namesOnly.filter(n => n !== correctAnswer), 3)]));
        } else {
            question = `___________ is standing far from the ${randomCategory}?`;
            correctAnswer = namesOnly[0];
            options = Array.from(new Set([correctAnswer, ...getRandomItems(namesOnly.filter(n => n !== correctAnswer), 3)]));
        }
        //console.log(options)

        return {
            question,
            pattern,
            options: options.sort(() => 0.5 - Math.random()),
            correctAnswer,
            type: "nearfar"
        };
    }



    const generatePositionRanking = (): RankingTestQuestion => {
        const allCharacters = [...Object.entries(boysCharacters), ...Object.entries(girlsCharacters)];
        const shuffledCharacters = [...allCharacters].sort(() => 0.5 - Math.random()).slice(0, 5);
        const pattern = shuffledCharacters.map(([name, img]) => `${name}-${img}`);
        const namesOnly = shuffledCharacters.map(([name]) => name);

        const questionType = getRandomInt(1, 5);
        let question = "";
        let correctAnswer = "";
        let options: string[] = [];

        if (questionType === 1) {
            const idx = getRandomInt(0, namesOnly.length - 1);
            question = `Who is standing just before ${namesOnly[idx]}?`;
            correctAnswer = idx > 0 ? namesOnly[idx - 1] : "None";
            options = Array.from(new Set([correctAnswer, ...getRandomItems(namesOnly.filter(n => n !== correctAnswer), 3)]));
        } else if (questionType === 2) {
            const idx = getRandomInt(0, namesOnly.length - 1);
            question = `Who is standing just after ${namesOnly[idx]}?`;
            correctAnswer = idx < namesOnly.length - 1 ? namesOnly[idx + 1] : "None";
            options = Array.from(new Set([correctAnswer, ...getRandomItems(namesOnly.filter(n => n !== correctAnswer), 3)]));
        } else if (questionType === 3) {
            const idx1 = getRandomInt(0, namesOnly.length - 3);
            const idx2 = idx1 + 2;
            question = `Who is standing between ${namesOnly[idx1]} and ${namesOnly[idx2]}?`;
            correctAnswer = namesOnly[idx1 + 1];
            options = Array.from(new Set([correctAnswer, ...getRandomItems(namesOnly.filter(n => n !== correctAnswer), 3)]));
        } else if (questionType === 4) {
            const idx1 = getRandomInt(0, namesOnly.length - 1);
            const idx2 = getRandomInt(0, namesOnly.length - 1);
            question = `How many kids are between ${namesOnly[idx1]} and ${namesOnly[idx2]}?`;
            correctAnswer = Math.abs(idx1 - idx2) > 1 ? `${Math.abs(idx1 - idx2) - 1}` : "0";
            options = [correctAnswer, `${+correctAnswer + 1}`, `${+correctAnswer + 2}`, `${Math.max(0, +correctAnswer - 1)}`];
        } else if (questionType === 5) {
            const mid = Math.floor(namesOnly.length / 2);
            question = `Who is in the middle of the queue?`;
            correctAnswer = namesOnly[mid];
            options = Array.from(new Set([correctAnswer, ...getRandomItems(namesOnly.filter(n => n !== correctAnswer), 3)]));
        } else {
            const position = getRandomInt(1, namesOnly.length);
            question = `Who is standing at the ${positionArray[position - 1]} position from the left?`;
            correctAnswer = namesOnly[position - 1];
            options = Array.from(new Set([correctAnswer, ...getRandomItems(namesOnly.filter(n => n !== correctAnswer), 3)]));
        }

        return {
            question,
            pattern,
            options: options.sort(() => 0.5 - Math.random()),
            correctAnswer,
            type: "position"
        };
    };



    const generateImageRanking = (): RankingTestQuestion => {
        const unitLength = 16;
        const categories = Object.keys(patternBackground) as (keyof typeof patternBackground)[];
        const randomCategory = categories[Math.floor(Math.random() * categories.length)];
        const leftOrRight = Math.random() < 0.5 ? 'left' : 'right';

        const selectedTopic = patternBackground[randomCategory];
        const selectedPosition = getRandomInt(0, 9);

        const pattern: string[] = [];
        const totalLength = 16;

        const patternUnit = getRandomItems(selectedTopic, totalLength);

        for (let i = 0; i < totalLength; i++) {
            pattern.push(patternUnit[i % unitLength]);
        }
        //console.log(totalLength,selectedPosition)
        const correctAnswer = leftOrRight === 'left' ? pattern[selectedPosition] : pattern[totalLength - (selectedPosition + 1)];

        const options = new Set<string>();
        options.add(correctAnswer);
        while (options.size < 4) {
            const distractor = selectedTopic[getRandomInt(0, selectedTopic.length - 1)];
            if (!options.has(distractor)) {
                options.add(distractor);
            }
        }

        return {
            question: "___________ is the " + positionArray[selectedPosition] + " from the " + leftOrRight + " end in the given arrangement.",
            pattern: pattern,
            options: Array.from(options).sort(() => Math.random() - 0.5),
            correctAnswer,
            //selectedPosition,
            type: "image",
        };
    };


    const handleAnswer = (value: string) => {
        if (!question) return;
        setSelected(value);
        if (value === question.correctAnswer) {
            setShowImage(true);
            setTimeout(() => {
                setShowImage(false);
                createNewQuestion();
            }, 3000);
        }
    };

    useEffect(() => {
        createNewQuestion();
        document.title =
            "Mamas Guidance - OLYMPIAD - Class One - Logical Reasoning - Ranking Test";
    }, []);

    return (
        <>
            {!showImage ? (
                <div className="contentPart ranking-test  fillPreposition additionWord rankingTest" style={{ marginTop: "0" }}>
                    <div className='mb-5'>
                        <div className='mb-5'>
                            {question?.type == "sameelement" ?
                                (
                                    <>
                                        <div className="image-container">
                                            <img className="repeating"
                                                src={`${process.env.REACT_APP_API_URL ?? ""}${selectedElement ?? "question-mark.png"}`}
                                                alt="pattern-img" style={{display: 'inline-block', marginRight: '20px', width: "50px", height: "50px"}}
                                            />
                                            {question?.question}
                                        </div>
                                    </>
                                ) :
                                (
                                    <p>
                                        {question?.question}</p>
                                )}
                        </div>
                        <IonText>
                            {question?.type == "image" ?
                                <> <span className='fw-bold'>(Left)</span><br /></>
                                : <></>
                            }
                            <div className="mb-2" style={{ fontSize: "1.2rem" }}>
                                {question?.type == "image" && question.pattern.map((val, idx) => (
                                    <div key={idx} className="image-container">
                                        <img className="repeating"
                                            src={`${process.env.REACT_APP_API_URL ?? ""}${val ?? "question-mark.png"}`}
                                            alt="pattern-img"
                                        />
                                    </div>
                                ))}
                                {question?.type == "position" && question.pattern.map((val, idx) => (
                                    <div key={idx} className="image-container" style={{ textAlign: "center" }}>
                                        <img className="repeating"
                                            src={`${process.env.REACT_APP_API_URL ?? ""}${val?.split('-')[1] ?? "question-mark.png"}`}
                                            alt="pattern-img"
                                        />
                                        <span>{val?.split('-')[0]}</span>
                                    </div>
                                ))}
                                {question?.type == "nearfar" && question.pattern.map((val, idx) => (
                                    <div key={idx} className="image-container" style={{ textAlign: "center" }}>
                                        <img className="repeating"
                                            src={`${process.env.REACT_APP_API_URL ?? ""}${val?.split('-')[1] ?? "question-mark.png"}`}
                                            alt="pattern-img"
                                        />
                                        <span>{val?.split('-')[0]}</span>
                                    </div>
                                ))}
                                {question?.type == "nearfar" ? (
                                    <div className="image-container">
                                        <img className="repeating nearFarImage"
                                            src={`${process.env.REACT_APP_API_URL}${selectedNearFarBackground}`}
                                            alt="pattern-img"
                                        />
                                    </div>
                                ) : <></>}
                                {question?.type == "sameelement" && question.pattern.map((val, idx) => (
                                    <div key={idx} className="image-container" style={{ textAlign: "center" }}>
                                        <img className="repeating"
                                            src={`${process.env.REACT_APP_API_URL ?? ""}${val?.split('-')[0] ?? "question-mark.png"}`}
                                            alt="pattern-img"
                                        />
                                        <span>{val?.split('-')[1]}</span>
                                    </div>
                                ))}
                            </div>
                            {question?.type == "image" ?
                                <>
                                    <span className='float-end fw-bold mb-5'>(Right)</span>
                                </>
                                : <></>
                            }
                        </IonText>
                        <IonRadioGroup className="mb-5 displayFlex"
                            value={selected}
                            onIonChange={(e) => handleAnswer(e.detail.value)}
                        >
                            {question?.options.map((option, idx) => (
                                <IonItem
                                    key={idx}
                                    className={`mygrid grid-item ${selected === option
                                        ? option === question.correctAnswer
                                            ? "correct"
                                            : "errorOptions"
                                        : ""
                                        }`}
                                >
                                    <IonLabel style={(question.type !== "image") ? {} : { width: "auto" }}>
                                        {
                                            question.type === "image" ? (
                                                <img
                                                    src={`${process.env.REACT_APP_API_URL ?? ""}${option}`}
                                                    style={{ width: "50px" }}
                                                    alt="option-img"
                                                />
                                            )
                                                : question.type === "position" || question.type === "nearfar" || question.type === "sameelement" ? (
                                                    <span>{option}</span>
                                                )
                                                    :

                                                    <></>
                                        }
                                    </IonLabel>
                                    <IonRadio slot="start" value={option} />
                                </IonItem>
                            ))}
                        </IonRadioGroup>
                    </div>
                </div>
            ) : (
                <div className="contentPart showMiddle">
                    <img
                        style={{ height: "150px" }}
                        className="img-fluid"
                        src={process.env.REACT_APP_WELDONE_LINK ?? ""}
                        alt="Well Done"
                    />
                </div>
            )}
        </>
    );
};

export default RankingTest;
